module.exports = __webpack_public_path__ + "img/horizontal_3_6_r_pp1_9006.2660942a.png";